import { render, staticRenderFns } from "./transmit.vue?vue&type=template&id=0b6ffbee&"
import script from "./transmit.vue?vue&type=script&lang=js&"
export * from "./transmit.vue?vue&type=script&lang=js&"
import style0 from "./transmit.vue?vue&type=style&index=0&id=0b6ffbee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports